import cloneDeep from 'clone-deep'
import type { InputType } from 'config'
import { useEffect, useState } from 'react'
import { Modal } from 'stories/components'
import { InputConvert, InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import { ExpirationDatesItem } from './types'

const defaultInputs = (): Record<string, InputType> => {
  return {
    calculateBasedOn: {
      inputType: 'select',
      title: 'Calculate based on',
      options: {
        1: 'Today Date',
        2: 'Closing Date',
      },
    },
  }
}

export const ExpirationDatesPropUpdate = ({
  title,
  data,
  onClose,
  onUpdate,
}: {
  title: string
  data: ExpirationDatesItem
  onClose: Function
  onUpdate: Function
}) => {
  const [loading, setLoading] = useState(false)
  const [inputs, setInputs] = useState(defaultInputs())

  useEffect(() => {
    const newInputs = cloneDeep(inputs)
    Object.keys(newInputs).forEach((key) => {
      newInputs[key].value = (data as any)[key]
    })
    setInputs(newInputs)
  }, [])

  const onChange = (key: string, value: string) => {
    const newInputs = cloneDeep(inputs)
    value = InputConvert(newInputs[key], value)
    newInputs[key].error = InputValidate({ ...newInputs[key], value })
    newInputs[key].value = value
    setInputs(newInputs)
  }

  const onSubmit = async () => {
    let hasError = false

    let newInputs = cloneDeep(inputs)
    const data: Record<string, any> = {}
    for (const key in inputs) {
      newInputs[key].error = InputValidate(newInputs[key])
      data[key] = newInputs[key].value
      if (newInputs[key].error) hasError = true
    }
    setInputs(newInputs)
    if (hasError) return

    setLoading(true)

    data.calculateBasedOn = Number(data.calculateBasedOn)
    await onUpdate(data)
  }

  return (
    <Modal
      title={`${title} Properties`}
      titleOkay="Confirm"
      loading={loading}
      onClose={() => onClose()}
      onOk={onSubmit}
      isOpen
    >
      <div className="text-gray-900">
        <div className="w-144 gap-4 mb-3 mt-2">
          {Object.keys(inputs).map((key, index) => {
            const input = inputs[key]

            return (
              <div className="input" key={index}>
                <RenderInput input={input} Key={key} onChange={onChange} />
              </div>
            )
          })}
        </div>
      </div>
    </Modal>
  )
}
